// extracted by mini-css-extract-plugin
export default {"car-model":"carPreview_car-model__N35Sl"};